import { DEFINE_LANGUAGE_PROMPT } from "../constants/ai-tools.constants";
import { AI_PROMPT_LENGTH, AI_PROMPT_TONE, LENGTH_PROMPT, TONE_PROMPT, USER_INPUT_TEMPLATE_PROMPT } from "../constants/ai.constants";

const userInputPrompt = (userInput) => {
  if (!userInput) return '';
  return USER_INPUT_TEMPLATE_PROMPT.replace('[userInput]', userInput || '');
}

const tonePrompt = (tone = '') => {
  return TONE_PROMPT[tone] || TONE_PROMPT[AI_PROMPT_TONE.Friendly];
};

const lengthPrompt = (length = '') => {
  return LENGTH_PROMPT[length] || LENGTH_PROMPT[AI_PROMPT_LENGTH.Short];
}

const createSubpromptObject = (subPrompts, contextData) => {
  return subPrompts.reduce((acc, subPrompt) => {
    if (!subPrompt.isSelected) return acc;
    if (!subPrompt.key) return acc;
    if (!contextData[subPrompt.key]) return acc;
    return {
      ...acc,
      [subPrompt.key]: contextData[subPrompt.key]
    }
  }, {});
}

const promptTextLanguage = (text) => {
  return DEFINE_LANGUAGE_PROMPT.replace('[text]', text);
}

const aiUtils = {
  userInputPrompt,
  tonePrompt,
  lengthPrompt,
  createSubpromptObject,
  promptTextLanguage
};

export default aiUtils;
